var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center" } },
    [
      _c("b-container", {
        staticClass: "text-left",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("pyme.text", _vm.PRIVACY_POLICY_COMPANY_DATA)
          )
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "pyme",
        attrs: { src: "/static-appopensalud/img/logos/pyme.png" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cb7f992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cb7f992","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pyme.vue
// module id = 3865
// module chunks = 105